import { useEffect } from 'react';
import { useMe } from '@/features/auth';
import { useAppDispatch } from '@/app/hooks';
import { setUser, setUserLoading } from './model/userSlice';
import type { User } from './model/types';

// useUser — адаптер над нашим useMe (react-query из @/features/auth).
// Подкладывает результат /me в RTK userSlice, чтобы компоненты фронтендера,
// которые читают user через useAppSelector(selectUser), работали без правок.
// Маппит name → username (см. types.ts).
//
// Параметр canFetch сохранён для совместимости с сигнатурой mcms-front,
// но useMe уже гейтит запрос наличием HMAC-cookies — параметр сейчас
// нужен только для документации сценария "не делать запрос вне cabinet".

export const useUser = (_: { canFetch?: boolean } = {}) => {
  const dispatch = useAppDispatch();
  const { data, isLoading } = useMe();

  useEffect(() => {
    dispatch(setUserLoading(isLoading));
  }, [dispatch, isLoading]);

  useEffect(() => {
    if (!data) return;
    const user: User = { ...data, username: data.name };
    dispatch(setUser(user));
  }, [dispatch, data]);
};
